import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { RadioSensor } from 'z3k-config';
import { useEditingProps, useGetZ3kObject } from '../../utils/unpack-props';
import { reactionsAndGuardZonesOptions } from 'console/device-settings/z3k/components/utils/z3k-selectors';
import { SettingContainer } from 'console/device-settings/z3k/components/material-utils/settings-card/container';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { MultipleSelectionTable, } from '../../material-utils/multiple-selection-table/multiple-selection';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
const z3k_name = 'radiosensors';
export const Fob868 = memo(function RadioFob868() {
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { config } = useContext(Z3KSettingsEditor);
    const reactions_and_guard_zones_options = reactionsAndGuardZonesOptions(config);
    const guardZoneOptions = useMemo(() => reactions_and_guard_zones_options.filter((option) => option.name === 'Охранные зоны'), [reactions_and_guard_zones_options]);
    const doOptions = useMemo(() => reactions_and_guard_zones_options.filter((option) => option.name !== 'Охранные зоны'), [reactions_and_guard_zones_options]);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const multipleSelectionTableOptions = useMemo(() => {
        const result = [
            {
                title: 'Список охранных зон для управления',
                help_id: 'fob_buttons_guard_zones',
                z3k_field: 'rol_movement_leakage_triggered',
                options: guardZoneOptions,
            },
            {
                title: 'Список действий при нажатии на дополнительную кнопку',
                help_id: 'fob_buttons_press_button_actions',
                z3k_field: 'rol_temperature_upper_threshold',
                options: doOptions,
            },
        ];
        if (RadioSensor.isFobWithSecondAddButton(item)) {
            result.push({
                title: 'Список действий при нажатии на дополнительную кнопку №2',
                help_id: 'fob_buttons_press_button_actions',
                z3k_field: 'rol_temperature_lower_threshold',
                options: doOptions,
            });
        }
        return result;
    }, [item]);
    return (_jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "fobs_name", ...nameEditingProps }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false }) })] }));
});
